import { LocaleContext } from "@jti/app-context/contexts";
import { QueryClient, QueryClientProvider } from "@jti/rest-api";

import { AppRunner } from "./components/AppRunner";
import { RootContainer } from "./containers/RootContainer";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

type CartMiniAppProps = {
  onNavigate?: (url: string) => void;
  shopButtonLabel?: string;
};

export const CartMiniApp = ({ onNavigate, shopButtonLabel }: CartMiniAppProps) => {
  return (
    <LocaleContext.Provider value={"en-US"}>
      <QueryClientProvider client={queryClient}>
        <AppRunner />
        <RootContainer onNavigate={onNavigate} shopButtonLabel={shopButtonLabel} />
      </QueryClientProvider>
    </LocaleContext.Provider>
  );
};
